import { render, staticRenderFns } from "./LbaDialog.vue?vue&type=template&id=0b8fae9c"
import script from "./LbaDialog.vue?vue&type=script&lang=js"
export * from "./LbaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports